import {
    NinchatActionType,
    NinchatCreateIdentityWithAuthResetAccessAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createIdentityWithAuthResetAccess = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateIdentityWithAuthResetAccessAction}`,
    async (arg: NinchatActionParams<NinchatCreateIdentityWithAuthResetAccessAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateIdentityWithAuthResetAccessAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
